import React from "react";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import PersonIcon from "@mui/icons-material/Person";
import ListAltIcon from "@mui/icons-material/ListAlt";
import Layout from "../../components/layout/Layout";
import { useAdminName } from "./session";


export default function Admin() {
  const userName = useAdminName();

  return (
    <Layout userName={userName!} title="-ADMINISTER-">
      <Links />
    </Layout>
  );
}

type LinkType = {
  title: string;
  icon: React.ElementType;
  uri: string;
};

const Links = () => {
  const mypage: LinkType = {
    title: "マイページ",
    icon: PersonIcon,
    uri: "/",
  };

  const items: LinkType[] = [
    {
      title: "受講者一覧",
      icon: ListAltIcon,
      uri: "/users",
    },
    {
      title: "講座一覧",
      icon: ListAltIcon,
      uri: "/lectures",
    },
  ];

  return (
    <>
      <List>
        <LinkItem {...mypage} />
      </List>
      <Divider />
      <List>
        {items.map((link) => (
          <LinkItem key={link.title} {...link} />
        ))}
      </List>
    </>
  );
};

const LinkItem = (link: LinkType) => {
  return (
    <ListItem disablePadding>
      <ListItemButton component={Link} to={link.uri as string}>
        <link.icon />
        <ListItemText primary={link.title} />
      </ListItemButton>
    </ListItem>
  );
};
